import { useEffect, useState } from "react";
import Marquee from "react-text-marquee";
import ApexTournamentService from "../../../../../services/ApexTournamentService";
import ITournament from "../../../../Interfaces/Tournament";
import ITournamentApexRespawnLeaderboard from "../../../../Interfaces/TournamentApexRespawnLeaderboard";

type Props = {
  tournament: ITournament
  lobby: any
}

const ApexLeaderboardTab = (props:Props) => {
  const { tournament, lobby } = props;
  const [leaderboard, setLeaderboard] = useState<Array<ITournamentApexRespawnLeaderboard>>([]);
  const [leaderboardError, setShowLeaderboardError] = useState();
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    ApexTournamentService.getLobbyLeaderboard(tournament?.id, lobby.id)
      .then((Rleaderboard) => {
        setLeaderboard(Rleaderboard);
        setLoading(false);
      })
      .catch((error) => {
        setLeaderboard([]);
        setShowLeaderboardError(error.response.data.message);
        setLoading(false);
      });
  }, [tournament, lobby]);
  return (
    <>
      {/* <div className="column col-12">
        <h5 className="skp-text-primary">Leaderboard</h5>
      </div> */}
      {!leaderboardError && !loading && (
        <>
          <div className="column col-12 skp-card skp-text-light">
            <div className="columns m-2">
              <div className="column col-1 col-xs-2 mb-2">#</div>
              <div className="column col-2 mb-2">Team n.</div>
              <div className="column col-4 mb-2 col-xs-6">Team name</div>
              <div
                className="column col-2 mb-2 tooltip text-right"
                data-tooltip="Score"
              >
                Score
              </div>
              <div
                className="column col-1 mb-2 tooltip text-right hide-xs"
                data-tooltip="Wins"
              >
                W
              </div>
              <div
                className="column col-1 mb-2 tooltip text-right hide-xs"
                data-tooltip="Kills"
              >
                K
              </div>
              <div
                className="column col-1 mb-2 tooltip text-right hide-xs"
                data-tooltip="Damage"
              >
                D
              </div>
            </div>
            <div className="columns skp-text-primary m-2">
              {leaderboard &&
                leaderboard
                  .sort((a, b) => (Number(a.score) < Number(b.score) ? 1 : -1))
                  .map((team, index) => (
                    <>
                      <div className="column col-1 col-xs-2 mb-2">{index + 1}</div>
                      <div className="column col-2 mb-2">{Number(team.teamNum) - 1}</div>
                      <div className="column col-4 col-xs-6 mb-2"><Marquee text={team.teamName} /></div>
                      <div className="column col-2 mb-2 text-right">
                        {team.score}
                      </div>
                      <div className="column col-1 mb-2 text-right hide-xs">
                        {team.wins}
                      </div>
                      <div className="column col-1 mb-2 text-right hide-xs">
                        {team.kills}
                      </div>
                      <div className="column col-1 mb-2 text-right hide-xs">
                        {team.damageDealt}
                      </div>
                    </>
                  ))}
                  
            </div>
          </div>
        </>
      )}

      {leaderboardError && !loading && <>
        <div className="column col-12 mt-2 mb-2">
          <h6 className="skp-text-light">{leaderboardError}</h6>
          <div className="space-divider-20"></div>
        </div>
      </>}

      {loading && <>
        <div className="column col-12 mt-2 mb-2">
          <div className="loading"></div>
        </div>
      </>}
    </>
  );
};

export default ApexLeaderboardTab;
